import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from "../hooks/useAuth"
import useLang from '../hooks/useLang'

const DashFooter = () => {

    const { username, status } = useAuth()

    const { lang } = useLang()

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const onGoHomeClicked = () => navigate('/dash')

    let goHomeButton = null
    if (pathname !== '/dash') {
        goHomeButton = (
            <button
                className="dash-footer__button icon-button"
                title="Home"
                onClick={onGoHomeClicked}
            >
                <FontAwesomeIcon icon={faHouse} />
            </button>
        )
    }

    const content = (
        <footer className="dash-footer">
            {goHomeButton}
            <p>Current User: <span style={{ textTransform: 'uppercase' }}>{username}</span></p>
            <p>Status: <span style={{ textTransform: 'uppercase' }}>{status}</span></p>
            <p>Lang: <span style={{ textTransform: 'uppercase' }}>{lang}</span></p>
            <p>v0.12</p>
        </footer>
    )
    return content
}
export default DashFooter